import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const PURCHASES = [{
  name: 'Laura F.',
  city: 'Buenos Aires'
}, {
  name: 'Carlos M.',
  city: 'Santiago'
}, {
  name: 'Ana G.',
  city: 'Madrid'
}, {
  name: 'Roberto S.',
  city: 'Lima'
}, {
  name: 'María T.',
  city: 'Ciudad de México'
}, {
  name: 'Patricia L.',
  city: 'Bogotá'
}, {
  name: 'Diego R.',
  city: 'Barcelona'
}, {
  name: 'Carmen V.',
  city: 'Montevideo'
}, {
  name: 'José M.',
  city: 'Caracas'
}, {
  name: 'Isabel P.',
  city: 'San José'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showRandomPurchase();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showRandomPurchase = () => {
    const randomPurchase = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup (between 8 and 15 seconds)
      const nextDelay = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000);
      setTimeout(showRandomPurchase, nextDelay);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-fade-in-up md:bottom-8 md:left-8" data-id="element-189">
      <div className="bg-white rounded-lg shadow-xl border-l-4 border-green-500 p-4 flex items-center max-w-xs md:max-w-sm" data-id="element-190">
        <div className="mr-4 bg-green-100 rounded-full p-2" data-id="element-191">
          <CheckCircle className="h-6 w-6 text-green-600" data-id="element-192" />
        </div>
        <div data-id="element-193">
          <p className="text-sm font-bold text-gray-900" data-id="element-194">
            {currentPurchase.name} compró el MegaPack
          </p>
          <p className="text-xs text-gray-500" data-id="element-195">
            Desde {currentPurchase.city} • Hace unos instantes
          </p>
        </div>
      </div>
    </div>;
}